import {
  DEFAULT_LANGUAGE,
  FALLBACK_LANGUAGE,
  getLanguageFromURL,
  isLanguageSupported,
} from "../config/languages";
import { getLocalStorage, languageStorage } from "./localStorage";

const normalizePath = (path = "/") => {
  if (!path) return "/";
  if (path.startsWith("http")) return path;
  return path.startsWith("/") ? path : `/${path}`;
};

export const resolveLanguage = (preferredLanguage) => {
  if (preferredLanguage && isLanguageSupported(preferredLanguage)) {
    return preferredLanguage;
  }

  const stored = typeof window !== "undefined" ? getLocalStorage(languageStorage) : null;
  if (stored && isLanguageSupported(stored)) {
    return stored;
  }

  if (typeof window !== "undefined") {
    const fromUrl = getLanguageFromURL(window.location.pathname);
    if (fromUrl && isLanguageSupported(fromUrl)) {
      return fromUrl;
    }
  }

  return DEFAULT_LANGUAGE || FALLBACK_LANGUAGE;
};

export const stripLanguagePrefix = (path) => {
  const normalized = normalizePath(path);
  return normalized.startsWith("/fr/") ? normalized.replace(/^\/fr/, "") : normalized;
};

export const withLanguagePrefix = (path, language) => {
  const normalized = normalizePath(path);

  if (normalized.startsWith("http")) {
    return normalized;
  }

  return normalized.startsWith("/fr/") ? normalized.replace(/^\/fr/, "") : normalized;
};

export const getLocalizedPath = (path, language) => {
  const resolvedLanguage = resolveLanguage(language);
  const normalized = normalizePath(path);

  if (resolvedLanguage === "fr") {
    if (normalized === "/about") return "/a-propos";
    if (normalized === "/news") return "/actualites";
    if (normalized === "/products") return "/produits";
    return stripLanguagePrefix(normalized);
  }

  if (resolvedLanguage === "en") {
    if (normalized === "/a-propos") return "/about";
    if (normalized === "/actualites") return "/news";
    if (normalized === "/produits") return "/products";
    return stripLanguagePrefix(normalized);
  }

  return withLanguagePrefix(normalized, resolvedLanguage);
};
